import React from 'react';
import {observer} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {
    Spinner,
    SpinnerTypeOptions,
    SpinnerBackgroundColors,
    SpinnerSizes
} from '@techsee/techsee-ui-common/lib/spinner';
import Translate from '../translate/Translate';

import './ts-idle-loader.style.scss';

export interface ITsIdleLoader {
    isToggleEnabled_IdleModeUsability: boolean;
    isDesktopSharingSession: boolean;
    displayLoaderReconnecting: boolean;
    endedTheMeeting: boolean;
    getLocale: () => string;
}

@observer
export class TsIdleLoader extends TechseeBaseComponent<ITsIdleLoader> {
    renderInternal(): JSX.Element {
        const {
            isToggleEnabled_IdleModeUsability,
            isDesktopSharingSession,
            displayLoaderReconnecting,
            endedTheMeeting,
            getLocale
        } = this.props;

        const shouldShow =
            isToggleEnabled_IdleModeUsability &&
            !isDesktopSharingSession &&
            displayLoaderReconnecting &&
            !endedTheMeeting;

        if (!shouldShow) {
            return <React.Fragment />;
        }

        // Get language info from the service (same as original vm controller)
        const lang = getLocale();
        const langFr = lang.includes('fr_FR');
        const langIt = lang.includes('it_IT');

        return (
            <div className='ts-idle-loader use-common-styles'>
                <Spinner
                    className='ts-idle-loader-spinner'
                    spinnerType={SpinnerTypeOptions.CIRCULAR}
                    backgroundColorName={SpinnerBackgroundColors.Transparent}
                    sizeName={SpinnerSizes.XSmall}
                />
                <div className={`ts-idle-loader-text ${langFr ? 'lang-fr' : ''} ${langIt ? 'lang-it' : ''}`}>
                    <Translate text='MAIN.VIEW.IDLE_CONNECTING' />
                </div>
            </div>
        );
    }
}
